import React from "react"
import { graphql } from "gatsby"
import { NavigationTile } from "./NavigationTile"
// import type { ReusableButtonGroup } from "_types/Button"
import type { SingleNagivationTile } from "./navigation-tile-type"

interface NavigationTilesProps {
  // reusable_button_group: ReusableButtonGroup | null
  alt_background_color: boolean
  eyebrow_text?: string | null
  heading: string | null
  nav_tiles_sub_heading: string | null
  navigation_tiles: SingleNagivationTile[] | null
}

export const NavigationTiles = ({
  // reusable_button_group,
  alt_background_color,
  eyebrow_text,
  heading,
  nav_tiles_sub_heading,
  navigation_tiles,
}: NavigationTilesProps) => {
  // Navigation tiles are a specific type of content block that is returned by Content blocks.
  const alternateBackground = alt_background_color
    ? "alternate-background-color"
    : ""

  return (
    <section
      className={
        heading || nav_tiles_sub_heading
          ? `u-content-block-padding u-clearfix ${alternateBackground}`
          : `nav-tile-container u-content-block-padding u-clearfix ${alternateBackground}`
      }
    >
      <div className="fr-container">
        {heading && (
          <div className="u-container-header">
            <div className="text-content-block__title">
              {eyebrow_text && <p className="eyebrow-text">{eyebrow_text}</p>}
              <h2>{heading}</h2>
            </div>
            {nav_tiles_sub_heading && <p>{nav_tiles_sub_heading}</p>}
          </div>
        )}
        <div className="nav-tile__wrapper">
          {navigation_tiles &&
            navigation_tiles.map(
              ({ id, ...tileProps }: SingleNagivationTile) => {
                if (
                  !tileProps ||
                  (tileProps && Object.keys(tileProps).length === 0)
                ) {
                  return
                }

                return (
                  <NavigationTile
                    key={id}
                    {...tileProps}
                    isDense={navigation_tiles.length > 4}
                  />
                )
              }
            )}
        </div>
      </div>
    </section>
  )
}

export const strapiQuery = graphql`
  fragment StrapiNavigationTilesFragment on STRAPI__COMPONENT_CONTENT_BLOCK_NAVIGATION_BLOCK {
    strapi_component
    id
    alt_background_color
    eyebrow_text
    heading
    nav_tiles_sub_heading: sub_heading
    navigation_tiles {
      ...StrapiNavigationTileFragment
    }
    reusable_button_group {
      ...StrapiReusableButtonFragment
    }
  }
`
